import { usePrevious } from '../utilities';
import { useEffect } from 'react';
import { FilterEventHandler } from 'react-bootstrap-table-next';
import useDebounce from '../../../utilities/hooks/useDebounce';

//FYI: this wrapper allows consumer to skip a bunch of reusable boilerplate in multiple filters
export const useDelayedOnFilterEffect = <S>(value: S, delay: number | undefined, onFilter: FilterEventHandler) => {
  const debouncedValue = useDebounce(value, delay || 0);
  const prevDebouncedValue = usePrevious(debouncedValue);

  useEffect(() => {
    // FYI: we don't want to send an event unless this "render" loop is the one where debouncedValue resolves to the latest/last value
    if (debouncedValue !== prevDebouncedValue) {
      onFilter(debouncedValue);
    }
  }, [debouncedValue, prevDebouncedValue, onFilter]);
  return debouncedValue !== value;
};
